export default __webpack_public_path__ + "4528edf012bd31e70b8b8bf62a8d5d56.png";